import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private configSubject = new BehaviorSubject<any | null>(null);
  config$ = this.configSubject.asObservable();
  private storageKey = 'app-config';

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return this.http
      .get<any>('/assets/config/config.json')
      .toPromise()
      .then((config) => {
        console.log('loading config')
        this.configSubject.next(config);
      })
      .catch((error) => {
        console.error('Error loading config, using default:', error);
        this.configSubject.next(null);
      });
  }

  // New method to get config asynchronously
  getConfigAsync(): Observable<any> {
    return this.config$.pipe(filter((config): config is any => config !== null),take(1)
    );
  }

  getConfig(): any | null {
    return this.configSubject.getValue();
  }
}